import React from 'react';
import styled from 'styled-components';
import HallScene from './Scenes/HallScene';
import ProfileScene from './Scenes/ProfileScene';
import GardenScene from './Scenes/GardenScene';
import LibraryScene from './Scenes/LibraryScene';
import QuizScene from './Scenes/QuizScene';

const SceneWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const SceneManager: React.FC = () => {
  return (
    <>
      <SceneWrapper className="section-wrapper">
        <HallScene />
      </SceneWrapper>
      
      <SceneWrapper className="section-wrapper">
        <ProfileScene />
      </SceneWrapper>
      
      <SceneWrapper className="section-wrapper">
        <GardenScene />
      </SceneWrapper>
      
      <SceneWrapper className="section-wrapper">
        <LibraryScene />
      </SceneWrapper>
      
      <SceneWrapper className="section-wrapper">
        <QuizScene />
      </SceneWrapper>
    </>
  );
};

export default SceneManager;
